// extracted by mini-css-extract-plugin
module.exports = {"container":"ResponsiveGraphic_container__3SYnN","control":"ResponsiveGraphic_control__NsP0T"};